import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../APICalls";

export default function Users(){


    document.getElementsByTagName("body")[0].classList.remove("login-page");
    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");



    const[users, setUsers] = useState([]);

    useEffect(() => {

        API.GetAllUsers().then((response) => {
            if(response.ok){
                response.json().then((data) => {
                    setUsers(data);
                });
            }
            else{
                alert("Token is not valid");
            }
        })
        .catch(() =>
        {
            alert("Cannot connect to LebenRaffle API");
        })

    }, []);

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Todos los Usuarios</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active">Todos los usuarios</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div class="card-header">
                                    <h3 class="card-title">Lista de usuarios</h3>
                                </div>
                                <div className="card-body">
                                    <table id="usersTable" className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="col-5">Nombre</th>
                                                <th className="col-5">Apellido</th>
                                                <th className="col-2">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.Name}</td>
                                                    <td>{item.Surname}</td>
                                                    <td>
                                                        <Link to={"/user/" + item.AccountId} className="btn btn-warning"><i className="fas fa-user-cog" /></Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}